export enum LISTING_TYPE {
  INSIGHT = "byInsight",
  PARTICIPANT = "byParticipant",
  QUESTION = "byQuestion",
  FILE = "byFile",
  SINGLE = "single",
  DEFAULT = "all",
}

export const listingPaths = {
  [LISTING_TYPE.DEFAULT]: LISTING_TYPE.DEFAULT,
  [LISTING_TYPE.INSIGHT]: LISTING_TYPE.INSIGHT,
  [LISTING_TYPE.PARTICIPANT]: LISTING_TYPE.PARTICIPANT,
  [LISTING_TYPE.QUESTION]: LISTING_TYPE.QUESTION,
  [LISTING_TYPE.FILE]: LISTING_TYPE.FILE,
  [LISTING_TYPE.SINGLE]: LISTING_TYPE.SINGLE,
};
